import axios from 'axios'
import store from '@/store'
import { CRM_API_URL } from '@/constants/api'

function fetchEmployeesWorkScheduleStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/work-schedule`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios
    .post(url, data, { cancelToken: source.token })
    .then((response) => response.data)
}

function exportEmployeesWorkScheduleStatistics (data) {
  const source = axios.CancelToken.source()
  const url = `${CRM_API_URL}/statistic/call-center/employees/work-schedule/export`
  store.dispatch('requests/addUniqueRequest', { url, source })

  return axios.post(url, data, {
    responseType: 'blob',
    cancelToken: source.token,
  })
}

export default {
  fetchEmployeesWorkScheduleStatistics,
  exportEmployeesWorkScheduleStatistics,
}
